"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagNeIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagNeIcon = (0, _mobxReact.observer)(_class = (_FlagNeIcon = /*#__PURE__*/function (_React$Component) {
  function FlagNeIcon() {
    _classCallCheck(this, FlagNeIcon);
    return _callSuper(this, FlagNeIcon, arguments);
  }
  _inherits(FlagNeIcon, _React$Component);
  return _createClass(FlagNeIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 100 100",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#FFFFFF",
        x: "0",
        y: "0",
        width: "100",
        height: "100"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#FF5252",
        points: "1.5 98.5 1.5 1.5 16.6 1.5 93 50.1 43.4 50.1 94.4 98.5"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M16.1,3 L87.8,48.6 L47.2,48.6 L39.7,48.6 L45.2,53.8 L90.7,97 L3.1,97 L3.1,3 L16.1,3 M17,0 L0,0 L0,100 L98.1,100 L47.2,51.6 L98.1,51.6 L17,0 L17,0 Z",
        id: "Shape",
        fill: "#003893"
      })), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#FFFFFF",
        points: "38.8 63.4 41 69.4 45.9 65.3 44.9 71.6 51.2 70.5 47.1 75.5 53.1 77.7 47.1 79.9 51.2 84.8 44.9 83.8 45.9 90.1 41 86 38.8 92 36.6 86 31.6 90.1 32.7 83.8 26.4 84.8 30.5 79.9 24.5 77.7 30.5 75.5 26.4 70.5 32.7 71.6 31.6 65.3 36.6 69.4"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M51.5,29.9 C50.6,33.1 48.7,35.8 46,37.6 L45.3,37.5 L47.6,35.4 L44.5,35.5 L46.2,32.9 L43.2,33.8 L44.1,30.8 L41.5,32.5 L41.6,29.4 L39.5,31.7 L38.8,28.7 L37.4,31.5 L36,28.7 L35.3,31.7 L33.2,29.4 L33.3,32.5 L30.7,30.8 L31.6,33.8 L28.6,32.9 L30.3,35.5 L27.2,35.4 L29.5,37.5 L28.8,37.6 C26.2,35.7 24.2,33 23.3,29.9 C23.3,30.1 23.3,30.3 23.3,30.5 C23.3,38.2 29.6,44.5 37.3,44.5 C45,44.5 51.3,38.2 51.3,30.5 C51.5,30.3 51.5,30.1 51.5,29.9 Z",
        id: "Path",
        fill: "#FFFFFF"
      }))));
    }
  }]);
}(_react["default"].Component), _FlagNeIcon.defaultProps = {
  width: '20px'
}, _FlagNeIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagNeIcon);